"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var isArrayLike_1 = require("../../utils/isArrayLike");

var ConditionalHelper_1 = require("../../helpers/ConditionalHelper");

var FilterTransform =
/** @class */
function (_super) {
  __extends(FilterTransform, _super);

  function FilterTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FilterTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var response = queryResponse;
    var filterConditional = this.options.conditional;

    if (queryResponse && isArrayLike_1.isArrayLike(queryResponse) && filterConditional) {
      var conditionalHelper_1 = new ConditionalHelper_1.ConditionalHelper(filterConditional, this.translationHelper);
      response = queryResponse.filter(function (record) {
        return conditionalHelper_1.matches(record);
      });
    }

    return response;
  };

  return FilterTransform;
}(BaseTransform_1.BaseTransform);

exports.FilterTransform = FilterTransform;